import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class InventoryTransfers_ds_get_inventory_transfer_by_inventoryTransferId_detailedService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { inventoryTransferId: number }): 
  Promise<{ result: { Id?: number, CreatedSysDateTime?: string, CreatedSysUser?: string, LookupCode?: string, ModifiedSysDateTime?: string, ModifiedSysUser?: string, Notes?: string, SourceProject?: { Id?: number, LookupCode?: string }, TargetProject?: { Id?: number, LookupCode?: string }, Status?: { Id?: number, Name?: string }, InventoryTransferLines?: { Id?: number, AllocationStrategyWorkflowCode?: string, AllowInactiveInventory?: boolean, ErrorMessage?: string, SourcePackageAmount?: number, SourceMaterial?: { Id?: number, LookupCode?: string }, SourceVendorLot?: { Id?: number, LookupCode?: string }, SourceLot?: { Id?: number, LookupCode?: string }, SourcePackage?: { Id?: number, Name?: string }, SourceLicensePlate?: { Id?: number, LookupCode?: string }, SourceSerialNumber?: { Id?: number, LookupCode?: string }, Warehouse?: { Id?: number, Name?: string }, TargetMaterial?: { Id?: number, LookupCode?: string }, Status?: { Id?: number, Name?: string }, TasksForInventoryTransferLine?: { Id?: number, OperationCodeId?: number, StatusId?: number }[] }[] } }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.inventoryTransferId)) {
      missingRequiredInParams.push('\'inventoryTransferId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/InventoryTransfers/datasources/ds_get_inventory_transfer_by_inventoryTransferId_detailed/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      inventoryTransferId: number    }) {
        if(isNil(inParams.inventoryTransferId)) {
          return true; 
        }
      return false;
    }
}
